import React from "react";

const ASPECT_RATIO = "845 / 227";

type MetaLogoPropsT = {
  width: number;
};

// The wordmark comes in a light and a dark cut, and which one applies is decided by the body class
// the admin sets - something a media query cannot see. The swap therefore lives in CSS next to the
// theme rules rather than here, which also keeps the browser from fetching both files.
export const MetaLogo = ({ width }: MetaLogoPropsT) => (
  <span aria-label="Meta" className="MetaLogo" role="img" style={{ width: `${width}px`, aspectRatio: ASPECT_RATIO }} />
);
